<template>
	<div class="manage_app p_background clearfix">
		<h3 class="all_title">应用审核列表</h3>
		<section class="all_container container_box">

			<!--all state start-->
			<div class="all_state clearfix">
				<div class="state_left">
					<ul>
						<li id="manage_all" class="state_active" @click="getAppCheckAuditList($event,0)">全部</li>
						<li id="manage_daishen" @click="getAppCheckAuditList($event,1)">等待审核({{counts.daishenCount}})</li>
						<li id="manage_zaishou" @click="getAppCheckAuditList($event,2)">正在销售({{counts.zaishouCount}})</li>
						<li id="manage_beijin" @click="getAppCheckAuditList($event,3)">被禁应用({{counts.beijinCount}})</li>
					</ul>
				</div>
				<div class="state_center text-right">
					<section class="search_box">
						<input id="manage_app_query" type="text" class="search_control" placeholder="输入应用名称查询" v-model.trim="appName" @keyup.enter="queryApp" />
						<i class="glyphicon icon_search" @click="queryApp()"></i>
					</section>
				</div>

			</div>
			<!--all state end-->

			<!--table start-->
			<div class="table_box user-select clearfix">
				<table class="table table-hover text-center">
					<thead>
						<tr>
							<th>应用名称</th>
							<th>版本编号</th>
							<th>状态</th>
							<th>申请时间</th>
							<th>申请人</th>
							<th>类型</th>
							<th>操作</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in page.content">
							<!-- 应用删除标记状态：已删除 -->
							<td class="text-left" v-if="item.delFlag == 0">
								<div class="inline-block apply_thumbnail cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">
									<img class="img_default" :src="item.filePath" alt="" />
								</div>
								<a class="cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">{{item.appName}}</a>
							</td>
							<!-- 禁止销售  -->
							<td class="text-left" v-else-if="item.appStatus == '3'">
								<div class="inline-block apply_thumbnail cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">
									<img class="img_default" :src="item.filePath" alt="" />
								</div>
								<a class="cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">{{item.appName}}</a>
							</td>

							<!-- 状态：等待审核 -->
							<td class="text-left" v-else-if="item.inspectStatus == '0'">
								<div class="inline-block apply_thumbnail cursor" @click="queryAppDetails(item.id,item.appVersionNo,0)">
									<img class="img_default" :src="item.filePath" alt="" />
								</div>
								<a class="cursor" @click="queryAppDetails(item.id,item.appVersionNo,0)">{{item.appName}}</a>
							</td>
							<!-- 状态：审核中 -->
							<td class="text-left" v-else-if="item.inspectStatus == '3'">
								<div class="inline-block apply_thumbnail cursor" @click="queryAppDetails(item.id,item.appVersionNo,0)">
									<img class="img_default" :src="item.filePath" alt="" />
								</div>
								<a class="cursor" @click="queryAppDetails(item.id,item.appVersionNo,0)">{{item.appName}}</a>
							</td>
							<!-- 状态：准备提交 -->
							<td class="text-left" v-else-if="item.inspectStatus == '9'">
								<div class="inline-block apply_thumbnail cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">
									<img class="img_default" :src="item.filePath" alt="" />
								</div>
								<a class="cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">{{item.appName}}</a>
							</td>
							<!-- 状态：审核未通过  -->
							<td class="text-left" v-else-if="item.inspectStatus == '2'">
								<div class="inline-block apply_thumbnail cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">
									<img class="img_default" :src="item.filePath" alt="" />
								</div>
								<a class="cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">{{item.appName}}</a>
							</td>

							<!-- 暂停销售  -->
							<td class="text-left" v-else-if="item.appStatus == '2'">
								<div class="inline-block apply_thumbnail cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">
									<img class="img_default" :src="item.filePath" alt="" />
								</div>
								<a class="cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">{{item.appName}}</a>
							</td>

							<!-- 其他  -->
							<td class="text-left" v-else>
								<div class="inline-block apply_thumbnail cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">
									<img class="img_default" :src="item.filePath" alt="" />
								</div>
								<a class="cursor" @click="queryAppDetails(item.id,item.appVersionNo,1)">{{item.appName}}</a>
							</td>

							<!-- 版本判断 -->
							<td v-if="item.appStatus == '1' && item.inspectStatus == '1'">
								{{item.appVersionNo}}
							</td>
							<td v-else>
								{{item.appVersionNo}}
							</td>

							<!-- 判定状态 -->
							<td v-if="item.delFlag == 0">已删除</td>
							<td class="color_24bb19" v-else-if="item.appStatus == '3'">禁止销售</td>

							<td class="color_2993ff" v-else-if="item.inspectStatus == '0'">等待审核</td>
							<td class="color_ff1212" v-else-if="item.inspectStatus == '9'">等待提交</td>
							<td class="color_2993ff" v-else-if="item.inspectStatus == '2'">审核不通过</td>
							<td class="color_2993ff" v-else-if="item.inspectStatus == '3'">正在审核</td>

							<td class="color_24bb19" v-else-if="item.appStatus == '2'">暂停销售</td>

							<td class="color_24bb19" v-else-if="item.inspectStatus == '1' && item.appStatus == '1' && item.publishStatus != '1'">等待发布</td>
							<td class="color_24bb19" v-else-if="item.inspectStatus == '1' && item.appStatus == '1' && item.publishStatus == '1'">可供销售</td>
							<td v-else>-</td>

							<td>{{item.inputTime|time}}</td>
							<td>{{item.chName}}</td>
							<td>{{item.businessTypeString}}</td>

							<!-- 根据状态显示操作  -->
							<!-- 状态：已删除  -->
							<td v-if="item.delFlag == 0">-</td>
							<!-- 状态：禁止销售  -->
							<td v-else-if="item.appStatus == '3'">
								<a class="cursor" @click="jiejin(item.id)">解除禁止</a>
							</td>

							<!-- 状态：等待审核 -->
							<td v-else-if="item.inspectStatus == '0'">
								<a class="cursor" @click="queryAppDetails(item.id,item.appVersionNo,0)">开始审核</a>
							</td>
							<!-- 状态：审核未通过  -->
							<td v-else-if="item.inspectStatus == '2'">-</td>
							<!-- 状态：审核中  -->
							<td v-else-if="item.inspectStatus == '3'">
								<a class="cursor" @click="queryAppDetails(item.id,item.appVersionNo,0)">开始审核</a>
							</td>
							<!-- 状态：等待提交  -->
							<td v-else-if="item.inspectStatus == '9'">-</td>
							<!-- app状态：暂停销售  -->
							<td v-else-if="item.appStatus == '2'">
								<a class="cursor" @click="jinzhiVal(item.id,item.appName)">禁止销售</a>
							</td>
							<!-- 状态：已上架正在销售的  -->
							<td v-else-if="item.inspectStatus == '1' && item.appStatus == '1'">
								<a class="cursor" @click="jinzhiVal(item.id,item.appName)">禁止销售</a>
							</td>
							<!-- 其他   -->
							<td v-else>-</td>

						</tr>
					</tbody>
				</table>
			</div>
			<!--table end-->
			<div class="text-center" v-bind:class="page.totalPages &gt; 0 ? 'show' : 'hidden'">
				<div class="row-fluid">
					<el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.total">
                    </el-pagination>
				</div>
			</div>
		</section>
		<input type="hidden" v-model="publishStatus" />
		<!--<input type="text" name="abc" value="def" @click="aaa($event)" />-->

		<!--提示模态框-->
		<v-tip></v-tip>

		<!--confirm-->
		<v-confirm v-if="confirmFlag" :bigMsg="bigMsg" @confirmOff="confirmFlag = !confirmFlag" @confirmTrue="jinzhi"></v-confirm>

	</div>

</template>

<script>
	import { MessageBox } from 'element-ui'

	export default {
		name: 'manage_app',
		data() {
			return {
				currentPage:1,
				pageSize:10,
				systemConfigList: '',
				page: '',
				counts: '',
				appName: '',
				publishStatus: '',
				bigMsg: '',
				confirmFlag: false,
				jinzhiId: '',
				jinzhiAppName: '',

			}
		},
		// 页面初始化
		created: function() {
			this.getSystemConfigList();
		},
		/*mounted: function() {
			this.$nextTick(function () {
			    this.getSystemConfigList();
			})			
		},*/
		methods: {
			getSystemConfigList() {
				this.currentPage=1;
				var temp = this;
				this.$http.post('/zklccloud/apps/toAppCheckAuditList', {
					"publishStatus": this.publishStatus,
					"page": this.currentPage - 1,
					"size":this.pageSize
				}, {
					emulateJSON: true
				}).then(function(m) {
						temp.page = m.body.content.page,
						temp.counts = m.body.content.countsMap
				})
			},
			handleSizeChange(val) {
        	this.pageSize = val;
        	this.currentPage = 1;
          var temp = this;
          this.$http.post('/zklccloud/apps/toAppCheckAuditList',{"publishStatus": this.publishStatus,"appName": this.appName,"page": this.currentPage - 1,"size":this.pageSize},{emulateJSON:true}).then(function(m){
	      	temp.page = m.data.content.page
		    })
        },
        handleCurrentChange(val) {
        	this.currentPage = val;
          var temp = this;
          this.$http.post('/zklccloud/apps/toAppCheckAuditList',{"publishStatus": this.publishStatus,"appName": this.appName,"page": val - 1,"size":this.pageSize},{emulateJSON:true}).then(function(m){
	      	temp.page = m.data.content.page
		    })
       },
			getAppCheckAuditList(e, publishStatus) {
				this.currentPage = 1;
				var temp = this;
				this.publishStatus = publishStatus;
				$(e.target).addClass("state_active").siblings().removeClass("state_active");
				temp.appName = '';
				this.$http.post('/zklccloud/apps/toAppCheckAuditList', {
					"publishStatus": this.publishStatus,
					"page": this.currentPage - 1,
					"size":this.pageSize
				}, {
					emulateJSON: true
				}).then(function(m) {
						temp.page = m.body.content.page,
						temp.counts = m.body.content.countsMap
				})
			},
			queryApp() {
				this.currentPage= 1;
				var temp = this;
				var appName = '';
				if(this.appName) {
					appName = this.appName;
				}
				this.$http.post('/zklccloud/apps/toAppCheckAuditList', {
					"appName": appName,
					"publishStatus": this.publishStatus,
					"page": this.currentPage - 1,
					"size":this.pageSize
				}, {
					emulateJSON: true
				}).then(function(m) {
						temp.page = m.body.content.page
					//temp.counts = m.body.content.countsMap
				})
			},
			queryAppDetails(appId, appversionid, flag) {
				this.$router.push({
					name: 'review_app',
					params: {
						appid: appId,
						versionId: appversionid,
						editFlag: flag
					}
				});
			},
			jiejin(id) {
				var temp = this;
				//解禁
				this.$http.post('/zklccloud/apps/updateAppStatusForShenhe', {
					"id": id,
					"whatOrder": '解禁'
				}, {
					emulateJSON: true
				}).then(function(m) {
					var ret = m.body;
					//					$("#one").modal().find(".state_text").html(ret.messageType);
					MessageBox(ret.messageType, '提示', 'warning', {
						confirmButtonText: '确定',
					});
					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					temp.$nextTick(function() {
						this.getSystemConfigList();
					})

				})
			},
			jinzhiVal(id, appName) {
				this.jinzhiId = id;
				this.jinzhiAppName = appName;
				this.confirmFlag = true;
				this.bigMsg = "禁止销售【" + this.jinzhiAppName + "】这个应用吗？";
			},
			jinzhi() {
				var temp = this;
				var id = this.jinzhiId;
				//禁止销售
				this.$http.post('/zklccloud/apps/updateAppStatusForShenhe', {
					"id": id,
					"whatOrder": '禁止'
				}, {
					emulateJSON: true
				}).then(function(m) {
					var ret = m.body;
					MessageBox(ret.messageType, '提示', 'warning', {
						confirmButtonText: '确定',
					});
					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					temp.confirmFlag = false;
					temp.$nextTick(function() {
						this.getSystemConfigList();
					})
				})

			},
			aaa(event) {
				//alert(event.target.value);
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s
	}
	
	.fade-enter,
	.fade-leave-active {
		opacity: 0
	}
</style>


// WEBPACK FOOTER //
// manage_app.vue?75b51ece